import { defineStore } from 'pinia'
import { ref } from 'vue'
import { initDatabase, saveToDb, getFromDb } from '@/utils/indexedDBHelper'
import { useUserStore } from './userStore'

const DB_NAME = 'dice_roller_db'
const DB_VERSION = 1
const STORE_NAME = 'recent_rolls'

export const useCriticalNotifierStore = defineStore('criticalNotifier', () => {
  const lastNotification = ref(null)
  const recentRolls = ref([]) // in-memory cache of recent rolls

  const emitNotification = (payload) => {
    // Debug: log payload and DOM mount info to help diagnose visibility issues
    try {
      if (
        typeof window !== 'undefined' &&
        window.__CRITICAL_NOTIFIER_DEBUG__ &&
        typeof console !== 'undefined' &&
        console.log
      )
        console.log('[CriticalNotifier][Store] emitNotification', payload)
      try {
        const mountEl =
          typeof document !== 'undefined'
            ? document.getElementById('global-dice-critical-notifier')
            : null
        const notifEl =
          typeof document !== 'undefined' ? document.querySelector('.critical-notifier') : null
        if (
          typeof window !== 'undefined' &&
          window.__CRITICAL_NOTIFIER_DEBUG__ &&
          typeof console !== 'undefined' &&
          console.log
        )
          console.log('[CriticalNotifier][Store] mountEl:', !!mountEl, 'notifEl:', !!notifEl)
        if (notifEl) {
          try {
            const cs = window.getComputedStyle(notifEl)
            if (
              typeof window !== 'undefined' &&
              window.__CRITICAL_NOTIFIER_DEBUG__ &&
              typeof console !== 'undefined' &&
              console.log
            )
              console.log('[CriticalNotifier][Store] notif computed zIndex:', cs.zIndex)
          } catch (e) {
            /* ignore getComputedStyle errors */
          }
        }
      } catch (e) {
        /* ignore DOM inspection errors */
      }
    } catch (e) {
      /* ignore logging errors */
    }

    lastNotification.value = { ...payload, timestamp: Date.now() }
  }

  const addRecentRoll = async (entry) => {
    try {
      const userStore = useUserStore()
      const uid = userStore.user?.uid || 'anon'
      await initDatabase(DB_NAME, DB_VERSION, STORE_NAME, null)
      const cacheKey = `recent_rolls_${uid}`

      // read existing
      const existing = (await getFromDb(DB_NAME, STORE_NAME, cacheKey)) || []
      const max = 100
      const updated = [
        {
          timestamp: Date.now(),
          ...entry
        },
        ...existing
      ].slice(0, max)

      await saveToDb(DB_NAME, STORE_NAME, cacheKey, 'user', uid, updated)
      recentRolls.value = updated
    } catch (e) {
      console.warn('criticalNotifierStore: failed to add recent roll', e)
    }
  }

  const loadRecentRolls = async () => {
    try {
      const userStore = useUserStore()
      const uid = userStore.user?.uid || 'anon'
      await initDatabase(DB_NAME, DB_VERSION, STORE_NAME, null)
      const cacheKey = `recent_rolls_${uid}`
      const existing = (await getFromDb(DB_NAME, STORE_NAME, cacheKey)) || []
      recentRolls.value = existing
      return existing
    } catch (e) {
      console.warn('criticalNotifierStore: failed to load recent rolls', e)
      return []
    }
  }

  const getLastN = (n = 3) => {
    return recentRolls.value.slice(0, n)
  }

  return {
    lastNotification,
    recentRolls,
    emitNotification,
    addRecentRoll,
    loadRecentRolls,
    getLastN
  }
})
